<script>
import { YEARS } from '@/components/shared/fault-consts';
import MomentTimezone from 'moment-timezone';

export default {
  name: 'FaultMixin',
  methods: {
    formatMinDate(deviceCreatedAt) {
      const createdAt = MomentTimezone(deviceCreatedAt);
      const todayYearAgo = MomentTimezone().subtract(1, YEARS);

      return createdAt > todayYearAgo ? createdAt.toDate() : todayYearAgo.toDate();
    }
  }
};
</script>
